import { AppEnvironment } from '../shared/enums/enums';

const domainName = 'dev.rcscbs.com';

export const environment = {
  id: AppEnvironment.Development,
  production: false,
  canShowPosWindowAppDownloadOption: true,
  canShowPosAndroidAppDownloadOption: true,
  canShowTpmWindowAppDownloadOption: true,
  canShowTpmAndroidAppDownloadOption: true,
  canShowImsOption: true,
  canShowLabelFormat: true,
  domainName,
  companyApiUrl: `https://company-api.${domainName}/api`,
  companyUrl: `https://company.${domainName}`,
  tpmUrl: `https://productionsystem.${domainName}`,
  listerUrl: `https://lister.${domainName}`,
  posUrl: `https://pos.${domainName}`,
  posApiUrl: `https://pos-api.${domainName}/api`,
  imsUrl: `https://inventory.${domainName}`,
  imsApiUrl: `https://inventory-api.${domainName}/api`,
  datadogAppId: 'ff763832-6aad-4750-bba7-7d688bee231a',
  datadogClientToken: 'pub2ca53b9f0fde2e441c504414a5a3d6e3',
  environmentName: 'dev',
};

export enum ActiveApps {
  TPMPortal = 1,
  POS = 2,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
}
